import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { setToken } from "../lib/auth";
import { finishSsoLogin } from "../lib/oauth";

interface Props {
  onConnected: () => void;
}

// D-GOV-10 Phase 5: OAuth redirect landing. Exchanges the IdP code for a KW-self
// token, persists it, and enters the app.
export default function OAuthCallbackRoute({ onConnected }: Props) {
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    finishSsoLogin(window.location.search)
      .then((token) => {
        setToken(token);
        onConnected();
        nav("/", { replace: true });
      })
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, [nav, onConnected]);

  return (
    <div className="max-w-xl mx-auto px-6 py-12 space-y-4">
      {error ? (
        <>
          <h1 className="text-xl font-semibold text-red-400">Login fehlgeschlagen</h1>
          <p className="text-sm text-kw-text-muted">{error}</p>
          <a href="/connect" className="text-kw-l3 text-sm underline">
            Zurück zum Login
          </a>
        </>
      ) : (
        <p className="text-sm text-kw-text-muted">Anmeldung wird abgeschlossen…</p>
      )}
    </div>
  );
}
